import { Box } from '@mui/material'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import FieldItemWrapper from '../Components/FieldItemWrapper'
import RequiredFieldErrorMessage from '../Components/FieldItemWrapper/RequiredFieldErrorMessage'
import InputWithInnerLabel from '../Components/InputWithInnerLabel'
import { getFieldTypeRequiredErrorMessage } from 'packages/core'
import InfoMessageForWrongJson from '../Components/InfoMessageForWrongJson'
import InfoTooltip from '../Components/InfoTooltip'
import { getInfoTooltipFieldsConfig, getInfoTooltipItems } from 'packages/core'

const DEFAULT_INFO_TOOLTIP_FIELDS = [
    { field: 'FriendlyName', labelKey: 'Common_FriendlyName' },
    { field: 'Description', labelKey: 'Common_Description' },
]

const FixedList = ({ fieldType, isFormValidated, valueType }) => {
    const { t } = useTranslation()
    const infoTooltipFieldsConfig = (() => {
        const configFields = getInfoTooltipFieldsConfig()
        return configFields.length > 0 ? configFields : DEFAULT_INFO_TOOLTIP_FIELDS
    })()
    const [errorMessage, setErrorMessage] = useState('')
    useEffect(() => {
        if (isFormValidated) {
            setErrorMessage(getFieldTypeRequiredErrorMessage(fieldType))
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isFormValidated, fieldType])

    return (
        <FieldItemWrapper
            headerStyle={{ alignItems: 'baseline' }}
            title={fieldType?.Name}
            isRequired={fieldType?.IsRequired}
            fieldTypeScope={fieldType?.FieldTypeScope}
        >
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '1.6rem',
                    '& input': {
                        boxShadow: 'none',
                        fontSize: '1.5rem',
                        textTransform: 'capitalize',
                        color: '#3b454d',
                    },
                    '& .MuiFormControl-root': {
                        marginTop: '0 !important',
                    },
                }}
            >
                {fieldType?.[valueType]?.length ? (
                    fieldType?.[valueType]?.map((item, index) => (
                        <Box sx={{ display: 'flex', alignItems: 'center' }}>
                            <InputWithInnerLabel
                                key={`field-type-${index}`}
                                value={item?.ValueName}
                                placeholder={t('Common_To')}
                                disabled={true}
                                label={`${item?.FriendlyName}: `}
                            />
                            <InfoTooltip
                                items={getInfoTooltipItems(
                                    item,
                                    infoTooltipFieldsConfig,
                                    t,
                                )}
                            />
                        </Box>
                    ))
                ) : (
                    <InfoMessageForWrongJson />
                )}
                <Box paddingLeft={'.2rem'}>
                    {Boolean(errorMessage) && (
                        <RequiredFieldErrorMessage errorMsgKey={errorMessage} />
                    )}
                </Box>
            </Box>
        </FieldItemWrapper>
    )
}

export default FixedList
